/* global vis*/
/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of drugs (patdrugss) to dispay or load drugs/patdrugss depending on mode */


(function () {
  'use strict';
  angular.module('vcdrug')
    .component('drughistory', {
      restrict: 'E',
      bindings: {
        patientid: '<'
      },
      template: `
        <hr class="spacer-bottom spacer-top">
        <h4>Medikationshistorie</h4>
          <div class="alert alert-info" ng-show="vm.ready === 'loading'">
            <i class="fa fa-spinner fa-spin"></i> Medikation wird geladen ...
          </div>
          <div class="alert alert-info" ng-show="vm.totalcount === 0">
            <i class="fa fa-info-circle"></i> Keine Medikationsdaten gefunden!
          </div>
          <div id="drughistoryvis" ng-show="vm.totalcount > 0"></div>
          <div class="spacer-bottom">&nbsp;</div>
        </div>
  `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'Drug', 'vertxEventBusService', '$element', 'lodash', '$document',
        function ($log, Rlog, Drug, vertxEventBusService, $element, _, $document) {
          let vm = this;
          vm.ready = 'loading';

          // initialise timeline
          let timeline = null;

          // vm.patientid might be late propagating, get files on first change
          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue)
              && changes.patientid.currentValue.length > 0) {
              vm.patientid = changes.patientid.currentValue;
              getPatdrugs(vm.patientid);
            }
          };

          function getPatdrugs(patientid) {
            Drug.$searchBy('patientid', patientid).$then(function (drugs) {
              vm.patdrugs = [];
              if (angular.isArray(drugs) && drugs.length > 0) {
                vm.patdrugs = drugs[0];
                $log.info('patdrugs search result: ', drugs);
                calcdrugs(vm.patdrugs);
                drawdrugs(vm.patdrugs);
              }
            });
          }

          function calcdrugs(drugs) {
            vm.ready = 'done';
            vm.activecount = 0;
            vm.totalcount = 0;
            if (angular.isDefined(drugs) && angular.isDefined(drugs.drugs)) {
              vm.totalcount = drugs.drugs.length;
              let saveneeded = 0;
              for (let i = 0; i < drugs.drugs.length; i++) {
                // deactivate expired "once-off" drugs
                if (drugs.drugs[i] && drugs.drugs[i].active && drugs.drugs[i].end && drugs.drugs[i].end < moment().toISOString()) {
                  drugs.drugs[i].active = false;
                  drugs.drugs[i].print = false;
                  saveneeded++;
                }
                if (drugs.drugs[i] && drugs.drugs[i].active) {
                  vm.activecount++;
                }
                if (saveneeded > 0) {
                  save();
                }
              }
            } else {
              vm.activecount = 0;
              vm.totalcount = 0;
            }
          }

          function drawdrugs(drugs) {
            vm.ready = 'done';

            vm.totalcount = drugs.drugs.length;
            vm.activecount = 0;

            // create timeline data set
            // vis-timeline expects a data object containing items[]
            vm.data = {};
            vm.data.items = [];
            let atcs = [];
            let zlnumms = [];
            let pharmanrs = [];

            for (let i = 0; i < drugs.drugs.length; i++) {
              if (drugs.drugs[i]) {
                let item = {};

                // set item content
                if (angular.isString(drugs.drugs[i].name)) {
                  item.content = drugs.drugs[i].name.split(' ')[0] + ', ' + drugs.drugs[i].amount;
                } else {
                  item.content = drugs.drugs[i].amount;
                }

                // set item title/tooltip
                item.title = drugs.drugs[i].name + ', ' + drugs.drugs[i].amount;

                // attach comment to drug title/tooltip
                // comment is prescription comment
                if (angular.isString(drugs.drugs[i].comment)) {
                  item.title += ', ';
                  item.title += drugs.drugs[i].comment;
                }
                // privcomment is doctor only comment e.g reasons for change, termination, ...
                if (angular.isString(drugs.drugs[i].privcomment)) {
                  item.title += ', ';
                  item.title += drugs.drugs[i].privcomment;
                }
                // handle date, pseudo-end permanent medikation in 5 days time for better graphical representation
                item.start = drugs.drugs[i].startDate;
                if (angular.isString(drugs.drugs[i].endDate)) {
                  item.end = drugs.drugs[i].endDate;
                } else {
                  // item.end = new Date();
                  item.end = moment().add(5, 'days').toISOString();
                }
                item.className = drugs.drugs[i].color;
                // set group to atc drugtype or drug nr
                if (angular.isArray(drugs.drugs[i].atcarray) && drugs.drugs[i].atcarray.length > 0) {
                  item.group = drugs.drugs[i].atcarray[0];
                  atcs.push(drugs.drugs[i].atcarray[0]);
                } else if (angular.isDefined(drugs.drugs[i].ZLNUMM)) {
                  item.group = drugs.drugs[i].ZLNUMM;
                  zlnumms.push(drugs.drugs[i].ZLNUMM);
                } else if (angular.isDefined(drugs.drugs[i].pharmanr)) {
                  item.group = drugs.drugs[i].pharmanr;
                  pharmanrs.push(drugs.drugs[i].pharmanr);
                } else {
                  item.group = 0;
                }

                item.id = 'drughistitem' + i;
                vm.data.items.push(item);

              } // if drug not null
            } // iterate over drugs

            let options = {
              locale: 'de-at'

            };
            let groups = [];


            let a = _.uniq(atcs);
            let z = _.uniq(zlnumms);
            let p = _.uniq(pharmanrs);

            if (a.length > 0) {
              for (let i = 0; i < a.length; i++) {
                let tmp = {};
                tmp.id = a[i];
                tmp.content = 'ATC ' + a[i];
                groups.push(tmp);
              }
            }
            if (z.length > 0) {
              for (let i = 0; i < z.length; i++) {
                let tmp = {};
                tmp.id = z[i];
                tmp.content = 'ZLNUMM ' + z[i];
                groups.push(tmp);
              }
            }
            if (p.length > 0) {
              for (let i = 0; i < p.length; i++) {
                let tmp = {};
                tmp.id = p[i];
                tmp.content = 'PharmaNr ' + p[i];
                groups.push(tmp);
              }
            }

            // If we've actually changed the data set, then recreate the graph
            if (timeline !== null) {
              timeline.destroy();
            }

            // Create the timeline object
            let viselement = angular.element($document[0].querySelectorAll('#drughistoryvis'));

            // timeline = new vis.Timeline(viselement[0], vm.data.items, groups, options);
            // timeline = new vis.Timeline(viselement[0], vm.data.items, options);
            timeline = new vis.Timeline(viselement[0]);
            timeline.setOptions(options);
            timeline.setItems(vm.data.items);
            timeline.setGroups(groups);

          } // drawdrugs


          vertxEventBusService.on('patdrugs.update', function (message) {
            let messages = message.split(':');
            if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id) && vm.patdrugs._id === messages[0]) {
              vm.patdrugs.$refresh().$then(function (drugs) {
                drawdrugs(drugs);
                // $log.debug('refreshed patdrugs for drughistory: ', vm.patientid);
              }, function (error) {
                $log.error('refreshing patdrugs for drughistory failed: ', error, vm.patientid);
              });
            } else {
              $log.debug('refreshed patdrugs for drughistory, inital fetch for an undefined patdrug ');
              getPatdrugs();
            }
          });


        }] // controller
    }); // component

  // klammerfriedhof
}());
